export default __webpack_public_path__ + "static/media/mobile-dollar-svgrepo-com.70e93f0b.svg";